import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { baseCardRecipe, baseCardDescriptionRecipe, cardBodyRecipe, cardContentRecipe, cardImageRecipe, CardImageRecipeRecipe } from "@fenderdigital/ui-styled-system/recipes";

import { BaseComponent, UserService } from "@mypxplat/xplat/core";
import { css, cx } from "styled-system/css";

@Component({
  selector: "fui-card",
  templateUrl: "card.component.html",
  standalone: false,
})
export class FuiCardComponent extends BaseComponent implements OnInit {
  public usePanda: boolean = false;
  @Input() text: string;
  @Input() image: string;
  @Input() imageAsBackground: string;
  @Input() title: string;
  @Input() productImage: string;
  @Input() progress: string;
  @Input() imageAspectRatio: string = "16 / 9";
  @Input() darkBackgroundColor: string = "gray.950";
  @Output() imageClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() titleClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() cardClick: EventEmitter<any> = new EventEmitter<any>();
  baseCardRecipe = baseCardRecipe;
  baseCardDescriptionRecipe = baseCardDescriptionRecipe;
  cardBodyRecipe = cardBodyRecipe;
  cardContentRecipe = cardContentRecipe;

  public cardImageRecipeClass: string;
  public cardBodyRecipeClass: string;

  constructor(userService: UserService) {
    super(userService);
  }

  ngOnInit(): void {
    this.cardImageRecipeClass = cx(
      cardImageRecipe(),
      css({ aspectRatio: this.imageAspectRatio }),
      css({ borderRadius: "0px" }),
      css({ marginBottom: this.progress ? "0px" : "15px" }),
      css({
        _dark: {
          backgroundColor: this.darkBackgroundColor,
        },
      })
    );
    this.cardBodyRecipeClass = cx(
      cardBodyRecipe(),
      css({ borderRadius: "0px" }),
      css({
        _dark: {
          backgroundColor: this.darkBackgroundColor,
        },
      })
    );
  }
}
